import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { map } from 'rxjs/operator/map';

@Injectable()
export class ExpedientesService {

  ServicioLegalActivo:{};

  EXcodigo:string = "";
  EXtitulo="";
  EXcliente="";
  EXusuarioacargo="";
  EXfechaapertura="";
  EXfechacierre="";

  
  expedientes:any[]=[];
  expedienteActivo:{};
  actuacionActiva:{};
  constructor(private auth:AuthService, private http:HttpClient) { }
  
  getExpedientes( filtro, pagado=1, pagina=1, ordenacion ){

    filtro.ref==""?this.EXcodigo="-":this.EXcodigo=filtro.ref;
    filtro.titulo==""?this.EXtitulo="-":this.EXtitulo=filtro.titulo;
    filtro.cliente==""?this.EXcliente="-":this.EXcliente=filtro.cliente;
    filtro.usuarioacargo==""?this.EXusuarioacargo="-":this.EXusuarioacargo=filtro.usuarioacargo;
    filtro.fapertura==""?this.EXfechaapertura="-":this.EXfechaapertura=filtro.fapertura;
    filtro.fcierre==""?this.EXfechacierre="-":this.EXfechacierre=filtro.fcierre;

    
    if(this.auth.esAdmin()){
      let EXcliente=this.EXcliente;
      let tipo="admin";
      return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/expedientes/${this.EXcodigo}/${this.EXtitulo}/${this.EXusuarioacargo}/${this.EXfechaapertura}/${this.EXfechacierre}/${pagado}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {EXcliente, tipo} )
        .map(resp=>{
          return resp;
        });

    }else if(this.auth.esCliente()){
      
      let EXcliente= this.auth.usuarioActivo.CLnombre;
      let tipo="cliente";
      return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/expedientes/${this.EXcodigo}/${this.EXtitulo}/${this.EXusuarioacargo}/${this.EXfechaapertura}/${this.EXfechacierre}/${pagado}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`,{EXcliente, tipo} )
        .map(resp=>{
          return resp;
        });
    }
  }

  getExpediente(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/expediente/${codigo}` )
        .map(resp=>{
          if(resp["err"]==false){
            this.expedienteActivo=resp["expediente"];
            return resp["expediente"];
          }
           return false; 
        });
  }

  getExpedientesCliente(cliente, pagina){
    
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/expedientesById/${cliente.CLcodigo}/1/${pagina}` )
        .map(resp=>{
          return resp;
        });
  }

  getExpedientesByInterviniente(filtro, pagina=1, ordenacion){
    filtro.ref==""?this.EXcodigo="-":this.EXcodigo=filtro.ref;
    filtro.titulo==""?this.EXtitulo="-":this.EXtitulo=filtro.titulo;
    filtro.cliente==""?this.EXcliente="-":this.EXcliente=filtro.cliente;
    filtro.usuarioacargo==""?this.EXusuarioacargo="-":this.EXusuarioacargo=filtro.usuarioacargo;
    filtro.fapertura==""?this.EXfechaapertura="-":this.EXfechaapertura=filtro.fapertura;
    filtro.fcierre==""?this.EXfechacierre="-":this.EXfechacierre=filtro.fcierre;

    
    let EXcliente=this.EXcliente;
    let codInterviniente=this.auth.usuarioActivo.INcodigo;
      return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/expedientesByInterviniente/${this.EXcodigo}/${this.EXtitulo}/${this.EXusuarioacargo}/${this.EXfechaapertura}/${this.EXfechacierre}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {EXcliente, codInterviniente} )
        .map(resp=>{
          
          return resp;
        });
  }

  getExpedientesDeInterviniente(codInterviniente, filtro, pagina=1, ordenacion){
    filtro.ref==""?this.EXcodigo="-":this.EXcodigo=filtro.ref;
    filtro.titulo==""?this.EXtitulo="-":this.EXtitulo=filtro.titulo;
    filtro.cliente==""?this.EXcliente="-":this.EXcliente=filtro.cliente;
    filtro.usuarioacargo==""?this.EXusuarioacargo="-":this.EXusuarioacargo=filtro.usuarioacargo;
    filtro.fapertura==""?this.EXfechaapertura="-":this.EXfechaapertura=filtro.fapertura;
    filtro.fcierre==""?this.EXfechacierre="-":this.EXfechacierre=filtro.fcierre;

    
    let EXcliente=this.EXcliente;
      return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/expedientesByInterviniente/${this.EXcodigo}/${this.EXtitulo}/${this.EXusuarioacargo}/${this.EXfechaapertura}/${this.EXfechacierre}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {EXcliente, codInterviniente} )
        .map(resp=>{
          
          return resp;
        });


  }

  checkExiste(codExpediente){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/existe/${codExpediente}`)
      .map(resp=>{
        if(resp["contador"]==1){
          return true;
        }else{
          return false;
        }
      })
  }

  pagarExpediente(codExpediente){

    let formData=new FormData();
    formData.append("codExpediente",codExpediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/pagarExpediente`, formData)
    .map(resp=>{
      
      return resp;
    })
  }
//ADJUNTOS

  getAdjuntos(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/adjuntos/${codigo}` )
        .map(resp=>{
          
          if(resp["err"]==false){
            return resp["adjuntos"];
          }
           return false; 
        });
  }

  getAdjunto(codAdjunto){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/adjunto/${codAdjunto}`)
    .map(resp=>{
      return resp;
    })
  }

  borrarAdjunto(codAdjunto){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/expedientes/adjunto/${codAdjunto}`)
    .map(resp=>{
      return resp;
    });
  }

  insertAdjunto(adjunto, archivo){

    let formData:FormData=new FormData();
    
    formData.append("filekey", archivo, archivo.name);
    formData.append("adjunto", JSON.stringify(adjunto));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/insertAdjunto`, formData)
    .map(resp=>{
      return resp;
    })
  }

  updateAdjunto(adjunto, codigo){
    let body=JSON.stringify(adjunto);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/updateAdjunto/${codigo}`, body)
    .map(resp=>{
      return resp;
    })
  }

  descargarAdjunto(adjunto) {
    let body= JSON.stringify(adjunto);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/descargarAdjunto`, body, {responseType:'arraybuffer'})
    .map(res=>new Blob([res],{ type: 'application/pdf'}));
  } 

//INTERVINIENTES DEL EXPEDIENTE
  getIntervinientes(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/intervinientes/${codigo}` )
        .map(resp=>{
          
          if(resp["err"]==false){
            return resp["intervinientes"];
          }
           return false; 
        });
  }

  getInterviniente(codexpinterviniente){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/interviniente/${codexpinterviniente}`)
    .map(resp=>{
      
      return resp;
    });
  }

  updateInterviniente(codInterviniente, interviniente){

    let body= JSON.stringify(interviniente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/updateinterviniente/${codInterviniente}`,body)
    .map(resp=>{
      return resp;
    });
  }
  insertInterviniente(interviniente){
    interviniente.EIcodexpediente=this.expedienteActivo["EXcodigo"];
    let body=JSON.stringify(interviniente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/insertinterviniente`,body)
    .map(resp=>{
      return resp;  
    });
  }

  borrarInterviniente(codInterviniente){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Expedientes/interviniente/${codInterviniente}`)
    .map(resp=>{
      return resp;
    })
  }

//ACTUACIONES
  getActuaciones(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/actuaciones/${codigo}` )
        .map(resp=>{
          
          if(resp["err"]==false){
            return resp["actuaciones"];
          }
           return false; 
        });
  }

  getActuacion(codActuacion){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/actuacion/${codActuacion}`)
    .map(resp=>{
      this.actuacionActiva=resp["actuacion"];
      
      return resp["actuacion"];
    });
  }

  updateActuacion(actuacion, codActuacion){
    let body= JSON.stringify(actuacion);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/updateactuacion/${codActuacion}`,body)
    .map(resp=>{
      return resp;
    });
  }

  insertActuacion(actuacion){
    actuacion["EAcodexpediente"]=this.expedienteActivo["EXcodigo"];
    let body= JSON.stringify(actuacion);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/insertactuacion`,body)
    .map(resp=>{
      return resp;
    });
  }

  borrarActuacion(codActuacion){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Expedientes/Actuacion/${codActuacion}`)
    .map(resp=>{
      return resp;
    })
  }

  //ACTUACIONES ADJUNTOS


    getActuacionAdjuntos(codActuacion){
      return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/ActuacionAdjuntos/${codActuacion}` )
      .map(resp=>{
        return resp;
      });
    }

    getActuacionAdjunto(codAdjunto){
      return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/ActuacionAdjunto/${codAdjunto}` )
      .map(resp=>{
        return resp;
      })
    }


    insertActuacionAdjunto(adjunto, archivo){
      let formData:FormData=new FormData();
      
      formData.append("filekey", archivo, archivo.name);
      formData.append("adjunto", JSON.stringify(adjunto));

      return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/insertActuacionAdjunto`, formData)
      .map(resp=>{
        return resp;
      })
    }


    updateActuacionAdjunto(adjunto, codAdjunto){
      let body=JSON.stringify(adjunto);
      return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/updateActuacionAdjunto/${codAdjunto}`,body )
      .map(resp=>{
        return resp;
      });
    }

    borrarActuacionAdjunto(codAdjunto){
      return this.http.delete( `https://app.solucionlegal.es/API/index.php/Expedientes/ActuacionAdjunto/${codAdjunto}` )
      .map(resp=>{
        return resp;
      });
    }

    descargarAdjuntoActuacion(adjunto){
      let body= JSON.stringify(adjunto);

      return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/descargarAdjuntoActuacion`, body, {responseType:'arraybuffer'})
      .map(res=>new Blob([res],{ type: 'application/pdf'}));
    }


//PROVISIONES
  getProvisiones(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/provisiones/${codigo}` )
        .map(resp=>{
          
          if(resp["err"]==false){
            return resp["provisiones"];
          }
           return false; 
        });
  }

  getProvision(codProvision){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/provision/${codProvision}`)
    .map(resp=>{
      return resp;
    });
  }

  updateProvision(provision, codProvision){
    provision["EPcodexpediente"]=this.expedienteActivo["EXcodigo"];
    let body=JSON.stringify(provision);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/updateProvision/${codProvision}`,body)
    .map(resp=>{
      return resp;
    });
  }

  insertProvision(provision, archivo){
    provision["EPcodexpediente"]=this.expedienteActivo["EXcodigo"];
    let formData:FormData=new FormData();
    if(archivo){
      formData.append("filekey", archivo, archivo.name);
    }
    formData.append("provision", JSON.stringify(provision));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/insertProvision`, formData)
    .map(resp=>{
      return resp;
    });
  }

  borrarProvision(codProvision){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Expedientes/Provision/${codProvision}`)
    .map(resp=>{
      return resp;
    })
  }

  descargarAdjuntoProvision(provision){
    let body= JSON.stringify(provision);
    
    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/descargarAdjuntoProvision`, body, {responseType:'arraybuffer'})
    .map(res=>new Blob([res], {type: 'application/octet-stream'}));
  }


//SUPLIDOS

  getSuplidos(codigo){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Expedientes/suplidos/${codigo}` )
    .map(resp=>{
      
      if(resp["err"]==false){
        return resp["suplidos"];
      }
       return false; 
    });
  }

  getSuplido(codSuplido){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/suplido/${codSuplido}`)
    .map(resp=>{
      return resp;
    });
  }

  updateSuplido(suplido, codSuplido){
    suplido["EScodexpediente"]=this.expedienteActivo["EXcodigo"];
    let body=JSON.stringify(suplido);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/updateSuplido/${codSuplido}`,body)
    .map(resp=>{
      return resp;
    });
  }

  insertSuplido(suplido, archivo){
    
    suplido["EScodexpediente"]=this.expedienteActivo["EXcodigo"];
    let formData:FormData=new FormData();
    if(archivo){
      formData.append("filekey", archivo, archivo.name);
    }

    formData.append("suplido", JSON.stringify(suplido));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/insertSuplido`, formData)
    .map(resp=>{
      return resp;
    })
  }

  borrarSuplido(codSuplido){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Expedientes/Suplido/${codSuplido}`)
    .map(resp=>{
      return resp;
    })
  }

  descargarAdjuntoSuplido(suplido){
    let body= JSON.stringify(suplido);
    
    return this.http.post(`https://app.solucionlegal.es/API/index.php/expedientes/descargarAdjuntoSuplido`, body, {responseType:'arraybuffer'})
    .map(res=>new Blob([res],{ type: "application/octet-stream" }));
  }



  insertExpediente(expediente){
    let body=JSON.stringify(expediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/createexpediente`, body)
    .map(resp=>{
      if(resp["id_introducido"]){
        
        this.expedienteActivo=resp["expediente"];
      }
      return resp;
    });
  }

  insertExpedienteConsulta(expediente){
    let body=JSON.stringify(expediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/createexpedienteConsulta`, body)
    .map(resp=>{
      if(resp["id_introducido"]){
        
        this.expedienteActivo=resp["expediente"];
      }
      return resp;
    });
  }

  

  updateExpediente(expediente, codigoexpediente){

    let body=JSON.stringify(expediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/updateexpediente/${codigoexpediente}`, body )
    .map(resp=>{
      return resp;
    });
  }

  borrarExpediente(codExpediente){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/Expedientes/expediente/${codExpediente}`)
    .map(resp=>{
      return resp;
    })
  }

  registrarExpediente(expediente){

    let body=JSON.stringify(expediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Expedientes/registrarExpediente`, body)
    .map(resp=>{
      return resp;
    });
  }

  getUltimosExpedientesNoRegistrados(){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/ultimosExpedientesNoRegistrados`)
    .map(resp=>{
      return resp;
    });
  }


  guardarPreconsulta(email){
    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/guardarPreconsulta`, {email})
    .map(resp=>{
      return resp;
    })
  }

  guardarPreservicio(email){
    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/guardarPreservicio`, {email})
    .map(resp=>{
      return resp;
    })
  }

  cargarClienteWeb(codigo){
    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/cargarClienteWeb`, {codigo})
    .map(resp=>{
      return resp;
    });
  }

  cargarClienteWebServicio(codigo){
    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/cargarClienteWebServicio`, {codigo})
    .map(resp=>{
      return resp;
    });
  }

  insertExpedienteWeb(expediente){
    let body=JSON.stringify(expediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/createexpediente`, body)
    .map(resp=>{
      if(resp["id_introducido"]){
        
        this.expedienteActivo=resp["expediente"];
      }
      return resp;
    });
  }

  insertAdjuntoWeb(adjunto, archivo){

    let formData:FormData=new FormData();
    
    formData.append("filekey", archivo, archivo.name);
    formData.append("adjunto", JSON.stringify(adjunto));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/web/insertAdjunto`, formData)
    .map(resp=>{
      return resp;
    })
  }

  pagarExpedienteWeb(codExpediente){

    let formData=new FormData();
    formData.append("codExpediente",codExpediente);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Web/pagarExpediente`, formData)
    .map(resp=>{
      
      return resp;
    })
  }

  
  pagarServicioWeb(){
    let formData=new FormData();
    formData.append("servicio", JSON.stringify(this.ServicioLegalActivo));
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Web/pagarServicioLegal`, formData)
    .map(resp=>{
      return resp;
    })
  }

  
  getNuevosExpedientes( filtro, pagado=1, pagina=1, ordenacion ){
    filtro.ref==""?this.EXcodigo="-":this.EXcodigo=filtro.ref;
    filtro.titulo==""?this.EXtitulo="-":this.EXtitulo=filtro.titulo;
    filtro.cliente==""?this.EXcliente="-":this.EXcliente=filtro.cliente;
    filtro.usuarioacargo==""?this.EXusuarioacargo="-":this.EXusuarioacargo=filtro.usuarioacargo;
    filtro.fapertura==""?this.EXfechaapertura="-":this.EXfechaapertura=filtro.fapertura;
    filtro.fcierre==""?this.EXfechacierre="-":this.EXfechacierre=filtro.fcierre;

    let EXcliente=this.EXcliente;
    let tipo="admin";

    return this.http.post( `https://app.solucionlegal.es/API/index.php/Expedientes/ultimosExpedientes/${this.EXcodigo}/${this.EXtitulo}/${this.EXusuarioacargo}/${this.EXfechaapertura}/${this.EXfechacierre}/${pagado}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {EXcliente, tipo} )
    .map(resp=>{
      return resp;
    });

  }
  
  nuevosExpedientes(){

    return this.http.get(`https://app.solucionlegal.es/API/index.php/Expedientes/nuevosExpedientes`)
    .map(resp=>{
      return resp;
    });
  }
  
  
  
}



// WEBPACK FOOTER //
// ./src/app/services/expedientes.service.ts